import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { ControllerBase } from '../../_appCommon/base/ControllerBase';
import { ResetPasswordDataService } from '../../_dataservices/ResetPasswordDataService';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  providers: [ResetPasswordDataService]
})

export class ResetPasswordComponent extends ControllerBase implements OnInit
{
  public currentCustomer: any; // current logged-in customer
  public currentCustomerName: string = "";
  public donePassword: boolean = false;
  constructor(
    private customerDataService: CustomerDataService,
    private router: Router,
    protected resetPasswordDataService: ResetPasswordDataService) { super(); }

  ngOnInit(): void
  {
    this.getCustomerInfo();
  }
  private getCustomerInfo()
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id).subscribe((customerResponse: any) =>
      {
        this.currentCustomer = customerResponse.items.firstOrNull();
        if (this.currentCustomer)
        {
          AppClientContext.Instance.customerId = this.currentCustomer.id;
          this.currentCustomerName = this.currentCustomer.fullName;
        }
        else
        {
          this.router.navigate(["/ecommerce"]);
        }
      });
    }
    else
    {
      this.router.navigate(["/ecommerce"]);
    }
  }

  public cancelPasswordChange()
  {
    this.router.navigate(["/ecommerce"]);
  }

  public doPasswordChange()
  {
    this.donePassword = true;
    this.setInfoAlert("Procesando, espere por favor");
    let body =
    {
      loginId: this.currentCustomer.email,
      validationKey: 1,
      email: this.currentCustomer.email,
      token: 1,
      userType: 2
    };
    let customerId = this.currentCustomer.id;
    this.resetPasswordDataService.resetPassword(body,customerId)
      .subscribe((response: any) =>
      {
        this.setSuccessAlert("Cambio de contraseña exitoso, revise su correo electrónico");
        setTimeout(() =>
        {
          this.router.navigate(["/ecommerce"]);
        }, 3000);
      },
      (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }
}

